import { useState, useEffect, useRef } from 'react';
// import { useMemo, useCallback } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
// import AlertDialogExitConfirmation from '@/pages/_partials/AlertDialogExitConfirmation';
import StepSelectFolder from './_partials/sheets/SheetSelectFolder';
// import SheetReportFinalize from '@/pages/procedures/reports/report/edit/_partials/sheets/SheetReportFinalize';
// import { useExitConfirmation } from '@/lib/hooks/use-exit-confirmation';
import { useProcedureTemplate } from '@/lib/hooks/use-procedure-template';
// import { validateRequiredFields, initializeFormData } from '@/lib/hooks/use-create-procedure-report';
// import { useBalance } from '@/lib/contexts/balance-context';
import { horodatyApi } from '@/lib/utils/horodaty-api';
import { useGeolocation } from '@/lib/contexts/device-permissions-context';
import { useTranslation } from 'react-i18next';
import ProcedureReportForm, {
    LoadingSkeleton,
    ErrorState,
} from '@/pages/procedures/reports/_partials/form/ProcedureReportForm';
// import { useProcedureReportForm } from '@/pages/procedures/reports/_partials/form/useProcedureReportForm';

function ProcedureReportCreateContent() {
    const { t } = useTranslation();
    const { procedureId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    // const { refreshBalance } = useBalance();
    const { position } = useGeolocation();

    const searchParams = new URLSearchParams(location.search);
    const initialFolderId = searchParams.get('folderId') || location.state?.folderId;
    const initialParentSubfolderId = location.state?.parentSubfolderId;

    const { template, isLoading, error, notFound, refetch } = useProcedureTemplate(procedureId);

    // ============ ÉTATS DU BROUILLON ============
    const [isCreatingDraft, setIsCreatingDraft] = useState(false);
    const hasTriggeredAutoCreate = useRef(false);

    // NOTE: Après la création du brouillon, on redirige vers la page d'édition.
    // Les états et hooks ci-dessous étaient utilisés pour gérer le formulaire directement ici.
    // const [draftData, setDraftData] = useState(null);
    // const [isDraftReady, setIsDraftReady] = useState(false);
    // const [currentSectionIndex, setCurrentSectionIndex] = useState(initialFolderId ? 0 : -1);
    // const [isFinalizing, setIsFinalizing] = useState(false);
    // const [showFinalizeSheet, setShowFinalizeSheet] = useState(false);
    // const [folderName, setFolderName] = useState('');

    // // Configuration: utiliser la version du brouillon si disponible, sinon le template
    // const configuration = useMemo(() => {
    //     if (draftData?.procedureTemplateVersion?.configuration) {
    //         return draftData.procedureTemplateVersion.configuration;
    //     }
    //     return template?.configuration || null;
    // }, [draftData?.procedureTemplateVersion?.configuration, template?.configuration]);

    // // Hook formulaire partagé
    // const {
    //     formData,
    //     setFormData,
    //     uploadedPhotos,
    //     sections,
    //     totalPhotoCount,
    //     handleFieldChange,
    //     showPhotoCapture,
    //     isUploadingPhoto,
    //     handlePhotoCapture,
    //     handlePhotoCaptured,
    //     handleRemovePhoto,
    //     closePhotoCapture,
    //     buildAnswersWithPhotos,
    //     validatePhotoFields,
    // } = useProcedureReportForm({
    //     folderId: draftData?.folderId,
    //     interventionId: draftData?.interventionId,
    //     configuration,
    // });

    // // Initialiser les données du formulaire quand le template est chargé
    // useEffect(() => {
    //     if (template?.configuration) {
    //         setFormData(initializeFormData(template.configuration));
    //     }
    // }, [template?.configuration]);

    // Si un folderId initial est fourni, créer le brouillon immédiatement
    useEffect(() => {
        if (initialFolderId && template && !isCreatingDraft && !hasTriggeredAutoCreate.current) {
            hasTriggeredAutoCreate.current = true;
            handleCreateDraft({
                mode: 'existing',
                folderId: initialFolderId,
                parentSubfolderId: initialParentSubfolderId,
            });
        }
    }, [initialFolderId, initialParentSubfolderId, template, isCreatingDraft]);

    const templateColor = template?.configuration?.color || template?.color || 'var(--secondary)';
    const goBack = () => navigate(-1);

    // // Navigation (plus utilisée, la page ne gère plus que l'étape dossier)
    // const isOnFolderStep = currentSectionIndex === -1;
    // const currentSection = isOnFolderStep ? null : sections[currentSectionIndex];
    // const totalSections = sections.length;
    // const totalSteps = totalSections + 1;
    // const isLast = currentSectionIndex === totalSections - 1;

    // // Progress: folder step = 1/totalSteps, section 0 = 2/totalSteps, etc.
    // const progress = ((currentSectionIndex + 2) / totalSteps) * 100;

    // // Sauvegarder le brouillon avant de quitter
    // const saveDraftBeforeExit = useCallback(async () => {
    //     if (!draftData?.folderId || !draftData?.interventionId) return;
    //     try {
    //         const answers = buildAnswersWithPhotos();
    //         if (!answers) return;
    //         await horodatyApi.updateProcedureReport(draftData.folderId, draftData.interventionId, { answers });
    //         toast.success('Brouillon sauvegardé');
    //     } catch (err) {
    //         console.error('Erreur sauvegarde brouillon:', err);
    //     }
    // }, [draftData, buildAnswersWithPhotos]);

    // // Tracker si le brouillon vient d'être sauvegardé (pas de confirmation de sortie)
    // const [isDraftJustSaved, setIsDraftJustSaved] = useState(false);
    // useEffect(() => {
    //     setIsDraftJustSaved(false);
    // }, [formData, uploadedPhotos]);

    // const hasUnsavedChanges = (isDraftReady || currentSectionIndex > -1) && !isDraftJustSaved;
    // const { isDialogOpen, setIsDialogOpen, confirmExit, exitWithoutSave, requestExit, isSaving } = useExitConfirmation(
    //     hasUnsavedChanges,
    //     exitPath,
    //     { onBeforeExit: saveDraftBeforeExit },
    // );

    // ============ CRÉATION DU BROUILLON ============
    const handleCreateDraft = async ({ mode, folderName, folderId, parentSubfolderId }) => {
        setIsCreatingDraft(true);
        try {
            let targetFolderId = folderId;
            if (mode === 'new') {
                const folderResponse = await horodatyApi.createFolder({
                    nom: folderName,
                    latitude: position?.latitude,
                    longitude: position?.longitude,
                });
                targetFolderId = folderResponse.data?.data?.uniq_id;
                if (!targetFolderId) throw new Error('Échec de la création du dossier');
            }

            const draftPayload = {
                template_id: template.uniq_id,
                latitude: position?.latitude,
                longitude: position?.longitude,
            };
            if (parentSubfolderId) {
                draftPayload.parent_subfolder_id = parentSubfolderId;
            }

            const draftResponse = await horodatyApi.createProcedureReportDraft(targetFolderId, draftPayload);
            const intervention = draftResponse.data?.data;
            if (!intervention?.uniq_id) throw new Error('Échec de la création du brouillon');

            toast.success(t('procedures:brouillonCreeLesPhotosSerontHorodateesInstantane'));
            const reportViewPath = `/procedures/${procedureId}/reports/${intervention.uniq_id}`;
            const reportEditPath = `${reportViewPath}/edit`;
            // Replace the create page entry with the report view in history,
            // then push the edit page on top. This way, going back from edit
            // lands on the report view without creating a loop.
            navigate(reportViewPath, { replace: true });
            navigate(reportEditPath);
        } catch (err) {
            console.error('Erreur création brouillon:', err);
            toast.error(err.response?.data?.message || t('procedures:erreurLorsDeLaPreparationDuRapport'));
        } finally {
            setIsCreatingDraft(false);
        }
    };

    // // ============ NAVIGATION ============
    // const handleNext = () => {
    //     if (isLast) {
    //         setShowFinalizeSheet(true);
    //     } else {
    //         setCurrentSectionIndex((prev) => Math.min(prev + 1, totalSections - 1));
    //     }
    // };
    //
    // const handlePrev = () => {
    //     if (currentSectionIndex <= 0) {
    //         requestExit();
    //     } else {
    //         setCurrentSectionIndex((prev) => Math.max(prev - 1, 0));
    //     }
    // };

    // // ============ FINALISATION ============
    // const handleFinalize = async () => {
    //     if (!draftData) {
    //         toast.error('Erreur: brouillon non prêt');
    //         return;
    //     }
    //
    //     const { isValid, missingFields } = validateRequiredFields(template.configuration, formData);
    //     const photoValidation = validatePhotoFields();
    //
    //     if (!isValid || !photoValidation.isValid) {
    //         const allMissing = [
    //             ...missingFields.map((f) => f.label),
    //             ...photoValidation.missingFields.map((f) => f.label),
    //         ];
    //         toast.error(`Champs manquants : ${allMissing.join(', ')}`);
    //         setShowFinalizeSheet(false);
    //         return;
    //     }
    //
    //     setIsFinalizing(true);
    //     try {
    //         const answers = buildAnswersWithPhotos();
    //         await horodatyApi.finalizeProcedureReportDraft(draftData.folderId, draftData.interventionId, { answers });
    //         toast.success('Rapport finalisé avec succès !');
    //         refreshBalance();
    //         navigate('/folders');
    //     } catch (err) {
    //         console.error('Erreur finalisation:', err);
    //         toast.error(err.response?.data?.message || 'Erreur lors de la finalisation');
    //     } finally {
    //         setIsFinalizing(false);
    //         setShowFinalizeSheet(false);
    //     }
    // };

    // ============ RENDU ============
    if (isLoading) return <LoadingSkeleton onBack={goBack} />;

    if (error || notFound) {
        return (
            <ErrorState
                message={notFound ? t('procedures:procedureNonTrouvee') : t('procedures:erreurLorsDuChargement')}
                onRetry={refetch}
                onBack={goBack}
            />
        );
    }

    if (!template || !template.configuration?.sections?.length) {
        return <ErrorState message="Cette procédure n'a pas de configuration valide" onBack={goBack} />;
    }

    const hasAtLeastOneField = template.configuration.sections.some((section) => section.fields?.length > 0);
    if (!hasAtLeastOneField) {
        return (
            <ErrorState
                message="Cette procédure ne contient aucun champ. Ajoutez au moins un champ avant de créer un rapport."
                onBack={goBack}
            />
        );
    }

    // const stepLabel = isOnFolderStep
    //     ? `Étape 1 sur ${totalSteps}`
    //     : `Étape ${currentSectionIndex + 2} sur ${totalSteps}${totalPhotoCount > 0 ? ` • ${totalPhotoCount} photo${totalPhotoCount > 1 ? 's' : ''}` : ''}`;

    return (
        <ProcedureReportForm
            title={template.name}
            color={templateColor}
            currentSection={null}
            currentSectionIndex={-1}
            totalSections={0}
            progress={0}
            formData={{}}
            uploadedPhotos={{}}
            onBack={goBack}
            stepLabel="Étape 1"
            mode="create"
            showFooter={false}
            beforeContent={
                <StepSelectFolder
                    onSelect={handleCreateDraft}
                    isCreatingDraft={isCreatingDraft}
                    templateName={template.name}
                    templateColor={templateColor}
                />
            }
            /* NOTE: Les props ci-dessous ne sont plus nécessaires car la page redirige
               vers la page d'édition après création du brouillon.
            isUploadingPhoto={isUploadingPhoto}
            showPhotoCapture={showPhotoCapture}
            onFieldChange={handleFieldChange}
            onPhotoCapture={handlePhotoCapture}
            onPhotoCaptured={handlePhotoCaptured}
            onRemovePhoto={handleRemovePhoto}
            onClosePhotoCapture={closePhotoCapture}
            onNext={handleNext}
            onPrev={handlePrev}
            headerExtra={
                isDraftReady && (
                    <div className="bg-secondary/20 rounded-[8px] px-[10px] py-[4px]">
                        <span className="text-[11px] text-secondary font-medium">Brouillon</span>
                    </div>
                )
            }
            afterContent={
                <>
                    <AlertDialogExitConfirmation
                        open={isDialogOpen}
                        onOpenChange={setIsDialogOpen}
                        onConfirm={confirmExit}
                        onExitWithoutSave={exitWithoutSave}
                        isSaving={isSaving}
                        saveOnExit={isDraftReady}
                    />
                    <SheetReportFinalize
                        open={showFinalizeSheet}
                        onClose={() => setShowFinalizeSheet(false)}
                        onFinalize={handleFinalize}
                        onSaveDraft={async () => {
                            setShowFinalizeSheet(false);
                            await saveDraftBeforeExit();
                            setIsDraftJustSaved(true);
                        }}
                        isFinalizing={isFinalizing}
                        tokenCostPdf={2}
                        folderName={folderName}
                    />
                </>
            }
            */
        />
    );
}

export default function ProcedureReportCreate() {
    return <ProcedureReportCreateContent />;
}
